export default function Analytics() {
  return <div className="animate-fade-in"><h1 className="text-3xl font-bold">Analytics</h1></div>
}
